import React from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { TruthSection } from './components/TruthSection';
import { BookPresentationSection } from './components/BookPresentationSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TargetAudienceSection } from './components/TargetAudienceSection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeFAQSection } from './components/GuaranteeFAQSection';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen bg-brand-cream font-sans text-gray-900 selection:bg-brand-wine selection:text-white" data-id="element-0">
      <TopBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <TruthSection data-id="element-5" />
        <BookPresentationSection data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <TargetAudienceSection data-id="element-8" />
        <OfferSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <GuaranteeFAQSection data-id="element-11" />
      </main>

      <PurchasePopup data-id="element-12" />

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-13">
        <p data-id="element-14">
          © {new Date().getFullYear()} MERECES MÁS. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}